// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"573":"60c0950d","697":"7c899d3f"}[chunkId] + ".chunk.js";
};